export enum CognitoError {
  NO_CURRENT_USER = 'No current user',
  REFRESH_TOKEN_EXPIRED = 'Refresh Token has expired',
  ACCESS_TOKEN_REVOKED = 'Access Token has been revoked',
  USER_DOES_NOT_EXIST = 'User does not exist.',
}
